// extracted by mini-css-extract-plugin
export default {"container":"footer_container__lVxu8","copyright":"footer_copyright__hbaZG","brand":"footer_brand__zpGg0","address":"footer_address__09lBg"};